export const ORDER_KINDS = ['repair', 'exchange', 'sale', 'stock'];
export const ORDER_KIND_LABEL = {
    repair: 'Ремонт',
    exchange: 'Обмен',
    sale: 'Продажа',
    stock: 'Пополнение фонда',
};
export const ORDER_SOURCES = ['site', 'avito', 'phone', 'referral', 'walk_in', 'cabinet', 'internal'];
export const ORDER_SOURCE_LABEL = {
    site: 'Сайт',
    avito: 'Авито',
    phone: 'Звонок',
    referral: 'Рекомендация',
    walk_in: 'Пришёл сам',
    cabinet: 'Кабинет',
    internal: 'Внутренний',
};
export const ORDER_STATUSES = [
    'new',
    'pickup',
    'intake',
    'diag',
    'approve',
    'repair',
    'stand',
    'ready',
    'done',
    'cancelled',
    'declined',
];
/** Этапы, которые проходит заказ каждого типа. Новая заявка и забор — до первого этапа. */
export const STAGES_BY_KIND = {
    repair: ['intake', 'diag', 'approve', 'repair', 'stand', 'ready', 'done'],
    exchange: ['intake', 'diag', 'repair', 'stand', 'done'],
    stock: ['intake', 'diag', 'repair', 'stand', 'done'],
    sale: ['ready', 'done'],
};
export const TERMINAL_STATUSES = ['done', 'cancelled', 'declined'];
export const ACTIVE_WORK_STATUSES = ['intake', 'diag', 'approve', 'repair', 'stand'];
export const STATUS_META = {
    new: { label: 'НОВАЯ', name: 'Новая заявка', color: '#ECEAE4' },
    pickup: { label: 'ЗАБОР', name: 'Забор', color: '#868B93' },
    intake: { label: 'ПРИЁМКА', name: 'Приёмка', color: '#868B93' },
    diag: { label: 'ДИАГНОСТИКА', name: 'Диагностика', color: '#4C8DFF' },
    approve: { label: 'СОГЛАСОВАНИЕ', name: 'Согласование', color: '#F2C230' },
    repair: { label: 'РЕМОНТ', name: 'Ремонт', color: '#FF5A1F' },
    stand: { label: 'СТЕНД', name: 'Стенд', color: '#39C6D6' },
    ready: { label: 'ГОТОВ', name: 'Готов', color: '#5BD16B' },
    done: { label: 'ВЫДАН', name: 'Выдан', color: '#4A4F57' },
    cancelled: { label: 'ОТМЕНЁН', name: 'Отменён', color: '#4A4F57' },
    declined: { label: 'ОТКАЗ', name: 'Отказ от ремонта', color: '#4A4F57' },
};
export const OVERDUE_COLOR = '#FF5C5C';
/** Статус с учётом типа заказа и того, кто смотрит. */
export function statusMeta(status, kind, audience = 'staff') {
    const base = STATUS_META[status];
    if (status === 'done' && (kind === 'exchange' || kind === 'stock')) {
        return audience === 'client' && kind === 'exchange'
            ? { ...base, label: 'ЗАВЕРШЁН', name: 'Завершён' }
            : { ...base, label: 'НА СКЛАДЕ', name: 'На склад' };
    }
    if (status === 'ready' && kind === 'sale') {
        return { ...base, label: 'В РЕЗЕРВЕ', name: 'Ждёт выдачи' };
    }
    if (audience === 'client') {
        if (status === 'approve')
            return { ...base, label: 'СОГЛАСУЙТЕ', name: 'Ждёт вашего согласования' };
        if (status === 'new')
            return { ...base, label: 'ПРИНЯТА', name: 'Заявка принята' };
        if (status === 'intake')
            return { ...base, label: 'ПРИНЯТА', name: 'Рейка принята' };
    }
    return base;
}
export function stagesFor(kind) {
    return STAGES_BY_KIND[kind];
}
/** Индекс текущего этапа в линейке; -1 — заказ ещё до первого этапа (новая заявка, забор). */
export function stageIndex(kind, status) {
    return STAGES_BY_KIND[kind].indexOf(status);
}
/** Следующий статус по линейке этапов. null — дальше двигать нельзя. */
export function nextStatus(kind, status) {
    if (TERMINAL_STATUSES.includes(status))
        return null;
    const stages = STAGES_BY_KIND[kind];
    if (status === 'new' || status === 'pickup')
        return stages[0];
    const i = stages.indexOf(status);
    if (i < 0 || i >= stages.length - 1)
        return null;
    return stages[i + 1];
}
export function isOverdue(status, dueDate, today) {
    if (!dueDate)
        return false;
    if (TERMINAL_STATUSES.includes(status) || status === 'ready')
        return false;
    return dueDate < today;
}
export const ESTIMATE_STATUSES = ['none', 'draft', 'sent', 'approved', 'declined'];
export const APPROVAL_VIA = ['phone', 'avito', 'in_person', 'link', 'cabinet'];
export const APPROVAL_VIA_LABEL = {
    phone: 'по телефону',
    avito: 'в чате Авито',
    in_person: 'лично',
    link: 'по ссылке',
    cabinet: 'в кабинете',
};
export const LINE_STATES = ['bad', 'warn', 'ok', 'none'];
export const LINE_STATE_COLOR = {
    bad: '#FF5C5C',
    warn: '#F2C230',
    ok: '#5BD16B',
    none: '#4A4F57',
};
export const LINE_ACTIONS = ['Замена', 'Восстановление', 'Работа', 'Рекомендуем', '—'];
export const DELIVERY_METHODS = ['self', 'pickup', 'onsite'];
export const DELIVERY_METHOD_LABEL = {
    self: { title: 'Привезём сами', note: 'Снятые рейки или авто своим ходом' },
    pickup: { title: 'Заберите у нас', note: 'Заберём снятые рейки с площадки' },
    onsite: { title: 'Снятие на вашем посту', note: 'Выездной мастер снимет и установит' },
};
export const UNIT_STATES = ['at_client', 'in_stock', 'in_repair', 'ready', 'donor', 'scrapped'];
export const UNIT_STATE_LABEL = {
    at_client: 'У клиента',
    in_stock: 'На складе',
    in_repair: 'В ремонте',
    ready: 'Готова',
    donor: 'Донор',
    scrapped: 'Утиль',
};
export const UNIT_SOURCES = ['client', 'exchange', 'buyout', 'new'];
export const UNIT_SOURCE_LABEL = {
    client: 'Клиента',
    exchange: 'Обмен',
    buyout: 'Выкуп',
    new: 'Новая позиция',
};
export const PRODUCT_STATUSES = ['draft', 'published', 'archived'];
export const PAYMENT_METHODS = ['transfer', 'cash', 'card'];
export const PAYMENT_METHOD_LABEL = {
    transfer: 'Перевод',
    cash: 'Наличные',
    card: 'Карта',
};
export const RECEIPT_STATUSES = ['pending', 'issued', 'cancelled', 'not_required'];
export const RECEIPT_STATUS_LABEL = {
    pending: 'Выбить чек',
    issued: 'Чек выбит',
    cancelled: 'Чек аннулирован',
    not_required: 'Не нужен',
};
export const STAFF_ROLES = ['admin', 'manager', 'master', 'courier'];
export const STAFF_ROLE_LABEL = {
    admin: 'Администратор',
    manager: 'Менеджер',
    master: 'Мастер',
    courier: 'Курьер',
};
export const MEMBER_ROLES = ['owner', 'manager', 'accountant'];
export const MEMBER_ROLE_LABEL = {
    owner: 'Владелец',
    manager: 'Сотрудник',
    accountant: 'Бухгалтер',
};
export const ORG_TYPES = ['service', 'fleet', 'taxi', 'other'];
export const ORG_TYPE_LABEL = {
    service: 'Автосервис',
    fleet: 'Автопарк',
    taxi: 'Таксопарк',
    other: 'Другое',
};
export const ORG_STATUSES = ['lead', 'active', 'blocked'];
export const ORG_STATUS_LABEL = {
    lead: 'Новая',
    active: 'Активна',
    blocked: 'Заблокирована',
};
export const TAX_FORMS = ['npd', 'ip', 'ooo'];
export const TAX_FORM_LABEL = {
    npd: 'Самозанятый (НПД)',
    ip: 'ИП',
    ooo: 'ООО',
};
//# sourceMappingURL=statuses.js.map